import { AdditionalInfoApiRepository } from '@/app/repositories/api/AdditionalInfoApiRepository'
import { AdditionalInfoPresenter } from '@/app/ui/presenters/AdditionalInfoPresenter'
import { DependencyContainer } from 'tsyringe'
import { AuthApiRepository } from '@/app/repositories/api/AuthApiRepository'
import { AuthPresenter } from '@/app/ui/presenters/AuthPresenter'
import { RolePresenter } from '@/app/ui/presenters/RolePresenter'
import { HomePresenter } from '@/app/ui/presenters/HomePresenter'
import { DashboardPresenter } from '@/app/ui/presenters/DashboardPresenter'
import { NotificationPresenter } from '@/app/ui/presenters/NotificationPresenter'
import { HomebannerPresenter } from '@/app/ui/presenters/HomebannerPresenter'
import { BulletinPresenter } from '@/app/ui/presenters/BulletinPresenter'
import { FAQPresenter } from '@/app/ui/presenters/FAQPresenter'
import { TrainingCategoryPresenter } from '@/app/ui/presenters/TrainingCategoryPresenter'
import { GuideCategoryPresenter } from '@/app/ui/presenters/GuideCategoryPresenter'
import { RecomendationPresenter } from '@/app/ui/presenters/RecomendationPresenter'
import { TrainingMaterialPresenter } from '@/app/ui/presenters/TrainingMaterialPresenter'
import { GuideMaterialPresenter } from '@/app/ui/presenters/GuideMaterialPresenter'
import { GalleryImagePresenter } from '@/app/ui/presenters/GalleryImagePresenter'
import { OtherContentPresenter } from '@/app/ui/presenters/OtherContentPresenter'
import { PositionPresenter } from '@/app/ui/presenters/PositionPresenter'
import { MasterCarPresenter } from '@/app/ui/presenters/MasterCarPresenter'
import { MasterPresenter } from '@/app/ui/presenters/MasterPresenter'
import { UserReportPresenter } from '@/app/ui/presenters/UserReportPresenter'
import { BulletinReportPresenter } from '@/app/ui/presenters/BulletinReportPresenter'
import { AdditionalInfoReportPresenter } from '@/app/ui/presenters/AdditionalInfoReportPresenter'
import { TrainingMaterialReportPresenter } from '@/app/ui/presenters/TrainingMaterialReportPresenter'
import { QuickGuideReportPresenter } from '@/app/ui/presenters/QuickGuideReportPresenter'

import { UserApiRepository } from '@/app/repositories/api/UserApiRepository'
import { RoleApiRepository } from '@/app/repositories/api/RoleApiRepository'
import { DashboardApiRepository } from '@/app/repositories/api/DashboardApiRepository'
import { NotificationApiRepository } from '@/app/repositories/api/NotificationApiRepository'
import { HomebannerApiRepository } from '@/app/repositories/api/HomebannerApiRepository'
import { BulletinApiRepository } from '@/app/repositories/api/BulletinApiRepository'
import { FAQApiRepository } from '@/app/repositories/api/FAQApiRepository'
import { TrainingCategoryApiRepository } from '@/app/repositories/api/TrainingCategoryRepository'
import { GuideCategoryApiRepository } from '@/app/repositories/api/GuideCategoryRepository'
import { RecomendationApiRepository } from '@/app/repositories/api/RecomendationApiRepository'
import { TrainingMaterialApiRepository } from '@/app/repositories/api/TrainingMaterialRepository'
import { GuideMaterialApiRepository } from '@/app/repositories/api/GuideMaterialRepository'
import { GalleryImageApiRepository } from '@/app/repositories/api/GalleryImageRepository'
import { OtherContentApiRepository } from '@/app/repositories/api/OtherContentApiRepository'
import { PositionApiRepository } from '@/app/repositories/api/PositionApiRepository'
import { MasterCarApiRepository } from '@/app/repositories/api/MasterCarApiRepository'
import { MasterApiRepository } from '@/app/repositories/api/MasterApiRepository'
import { UserReportApiRepository } from '@/app/repositories/api/UserReportApiRepository'
import { AdminCMSPresenter } from '@/app/ui/presenters/AdminCMSPresenter'
import { AdminCMSRolePresenter } from '@/app/ui/presenters/AdminCMSRolePresenter'
import { AdminCMSApiRepository } from '@/app/repositories/api/AdminCMSApiRepository'
import { AdminCMSRoleApiRepository } from '@/app/repositories/api/AdminCMSRoleApiRepository'
import { BulletinReportApiRepository } from '@/app/repositories/api/BulletinReportApiRepository'
import { AdditionalInfoReportApiRepository } from '@/app/repositories/api/AdditionalInfoReportApiRepository'
import { TrainingMaterialReportApiRepository } from '@/app/repositories/api/TrainingMaterialReportApiRepository'
import { QuickGuideReportApiRepository } from '@/app/repositories/api/QuickGuideReportApiRepository'
import { NotificationReportReportPresenter } from '@/app/ui/presenters/NotificationReportPresenter'
import { NotificationReportApiRepository } from '@/app/repositories/api/NotificationReportApiRepository'

export class PresenterModule {
  public static init(container: DependencyContainer) {
    container.register<AuthPresenter>(AuthPresenter, {
      useFactory: (d) => {
        return new AuthPresenter(d.resolve(AuthApiRepository))
      },
    })
    container.register<HomePresenter>(HomePresenter, {
      useFactory: (d) => {
        return new HomePresenter(d.resolve(UserApiRepository))
      },
    })
    container.register<RolePresenter>(RolePresenter, {
      useFactory: (d) => {
        return new RolePresenter(d.resolve(RoleApiRepository))
      },
    })
    container.register<DashboardPresenter>(DashboardPresenter, {
      useFactory: (d) => {
        return new DashboardPresenter(d.resolve(DashboardApiRepository))
      },
    })
    container.register<NotificationPresenter>(NotificationPresenter, {
      useFactory: (d) => {
        return new NotificationPresenter(d.resolve(NotificationApiRepository))
      },
    })
    container.register<HomebannerPresenter>(HomebannerPresenter, {
      useFactory: (d) => {
        return new HomebannerPresenter(d.resolve(HomebannerApiRepository))
      },
    })
    container.register<AdditionalInfoPresenter>(AdditionalInfoPresenter, {
      useFactory: (d) => {
        return new AdditionalInfoPresenter(
          d.resolve(AdditionalInfoApiRepository)
        )
      },
    })
    container.register<BulletinPresenter>(BulletinPresenter, {
      useFactory: (d) => {
        return new BulletinPresenter(d.resolve(BulletinApiRepository))
      },
    })
    container.register<FAQPresenter>(FAQPresenter, {
      useFactory: (d) => {
        return new FAQPresenter(d.resolve(FAQApiRepository))
      },
    })
    container.register<TrainingCategoryPresenter>(TrainingCategoryPresenter, {
      useFactory: (d) => {
        return new TrainingCategoryPresenter(
          d.resolve(TrainingCategoryApiRepository)
        )
      },
    })
    container.register<GuideCategoryPresenter>(GuideCategoryPresenter, {
      useFactory: (d) => {
        return new GuideCategoryPresenter(d.resolve(GuideCategoryApiRepository))
      },
    })
    container.register<RecomendationPresenter>(RecomendationPresenter, {
      useFactory: (d) => {
        return new RecomendationPresenter(
          d.resolve(RecomendationApiRepository),
          d.resolve(GuideCategoryApiRepository),
          d.resolve(TrainingCategoryApiRepository),
          d.resolve(AdditionalInfoApiRepository),
          d.resolve(BulletinApiRepository)
        )
      },
    })
    container.register<TrainingMaterialPresenter>(TrainingMaterialPresenter, {
      useFactory: (d) => {
        return new TrainingMaterialPresenter(
          d.resolve(TrainingMaterialApiRepository)
        )
      },
    })
    container.register<GuideMaterialPresenter>(GuideMaterialPresenter, {
      useFactory: (d) => {
        return new GuideMaterialPresenter(d.resolve(GuideMaterialApiRepository))
      },
    })
    container.register<GalleryImagePresenter>(GalleryImagePresenter, {
      useFactory: (d) => {
        return new GalleryImagePresenter(d.resolve(GalleryImageApiRepository))
      },
    })
    container.register<OtherContentPresenter>(OtherContentPresenter, {
      useFactory: (d) => {
        return new OtherContentPresenter(d.resolve(OtherContentApiRepository))
      },
    })
    container.register<PositionPresenter>(PositionPresenter, {
      useFactory: (d) => {
        return new PositionPresenter(d.resolve(PositionApiRepository))
      },
    })
    container.register<MasterCarPresenter>(MasterCarPresenter, {
      useFactory: (d) => {
        return new MasterCarPresenter(d.resolve(MasterCarApiRepository))
      },
    })
    container.register<MasterPresenter>(MasterPresenter, {
      useFactory: (d) => {
        return new MasterPresenter(d.resolve(MasterApiRepository))
      },
    })
    container.register<UserReportPresenter>(UserReportPresenter, {
      useFactory: (d) => {
        return new UserReportPresenter(d.resolve(UserReportApiRepository))
      },
    })
    container.register<AdminCMSPresenter>(AdminCMSPresenter, {
      useFactory: (d) => {
        return new AdminCMSPresenter(d.resolve(AdminCMSApiRepository))
      },
    })
    container.register<AdminCMSRolePresenter>(AdminCMSRolePresenter, {
      useFactory: (d) => {
        return new AdminCMSRolePresenter(d.resolve(AdminCMSRoleApiRepository))
      },
    })
    container.register<BulletinReportPresenter>(BulletinReportPresenter, {
      useFactory: (d) => {
        return new BulletinReportPresenter(
          d.resolve(BulletinReportApiRepository)
        )
      },
    })
    container.register<AdditionalInfoReportPresenter>(
      AdditionalInfoReportPresenter,
      {
        useFactory: (d) => {
          return new AdditionalInfoReportPresenter(
            d.resolve(AdditionalInfoReportApiRepository)
          )
        },
      }
    )
    container.register<NotificationReportReportPresenter>(
      NotificationReportReportPresenter,
      {
        useFactory: (d) => {
          return new NotificationReportReportPresenter(
            d.resolve(NotificationReportApiRepository)
          )
        },
      }
    )
    container.register<TrainingMaterialReportPresenter>(
      TrainingMaterialReportPresenter,
      {
        useFactory: (d) => {
          return new TrainingMaterialReportPresenter(
            d.resolve(TrainingMaterialReportApiRepository)
          )
        },
      }
    )
    container.register<QuickGuideReportPresenter>(QuickGuideReportPresenter, {
      useFactory: (d) => {
        return new QuickGuideReportPresenter(
          d.resolve(QuickGuideReportApiRepository)
        )
      },
    })
  }
}
